module.exports = __webpack_public_path__ + "img/MEDIA049.59d461c2.jpg";